import { FC, useMemo } from 'react'
import { useRouter } from 'next/router'
import styled from 'styled-components'
import { useGqlSelfIntroductionInfosQuery } from 'generated/graphql'
import SearchResultNotFound from '@app.feature/coverletter/coverletter.write/screen/Toolbar/LoadModal/components/SearchResultList/SearchResultNotFound'
import BounceLoading from 'components/BounceLoading'
import FileItemMobile from './FileItemMobile'

const SelfIntroductionSearchResult: FC = () => {
  const router = useRouter()
  const query = useMemo(() => {
    return `${router.query.q || ''}`
  }, [router.query])

  const { data, loading } = useGqlSelfIntroductionInfosQuery({
    variables: {
      filterBy: {
        type: null,
        keyword: query,
      },
      pagination: {
        page: 1,
        pageSize: 1000,
      },
    },
  })

  if (!query) return <></>

  return (
    <StyledWrapper>
      <div className="total-count">
        자기소개서 검색 {data?.selfIntroductionInfos.totalCount}건
      </div>
      {(loading || !data) && (
        <div className="loading-wrapper">
          <BounceLoading className="loading" />
          <div className="loading-text">자기소개서를 불러오고 있습니다.</div>
        </div>
      )}
      {data?.selfIntroductionInfos.nodes.length === 0 && (
        <SearchResultNotFound searchKeyword={query} />
      )}
      {data?.selfIntroductionInfos.nodes.map((node) => (
        <div key={`SearchResultList-${node.id}`} className="file-item">
          <FileItemMobile data={node.selfIntroduction} keyword={query} />
        </div>
      ))}
    </StyledWrapper>
  )
}

export default SelfIntroductionSearchResult

const StyledWrapper = styled.div`
  .loading-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 100%;
    .loading {
      margin-bottom: 30px;
    }
    .loading-text {
      font-size: 14px;
      font-weight: 500;
      color: #999;
      text-align: center;
    }
  }
  .total-count {
    height: 50px;
    padding: 22px 20px 0;
    font-size: 12px;
    color: #999;
  }
  .file-item {
    background-color: #fff;
  }
`
